import { all } from "redux-saga/effects";
import authSaga from "./sagas/authSaga";
import configSaga from "./sagas/configSaga";
import contentSaga from "./sagas/contentSaga";
import deviceSaga from "./sagas/deviceSaga";
import doctorsSaga from "./sagas/doctorsSaga";
import goalsSaga from "./sagas/goalsSaga";
import insightsSaga from "./sagas/insightsSaga";
import labTestSaga from "./sagas/labTestSaga";
import locationSaga from "./sagas/locationSaga";
import medicationSaga from "./sagas/medicationSaga";
import offersSaga from "./sagas/offersSaga";
import onboardingSaga from "./sagas/onboardingSaga";
import patientSaga from "./sagas/patientSaga";
import programSaga from "./sagas/programSaga";
import razorPaySaga from "./sagas/razorPaySaga";
import recordsSaga from "./sagas/recordsSaga";
import reminderSaga from "./sagas/reminderSaga";
import appointmentSaga from "./sagas/appointmentSaga";
import orderHistorySaga from "./sagas/orderHistorySaga";
import journeySaga from "./sagas/journeySaga";
import symptomsSaga from "./sagas/symptomsSaga";
import walletSaga from "./sagas/WalletSaga";
import cgmSaga from "./sagas/cgmSaga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    configSaga(),
    contentSaga(),
    deviceSaga(),
    doctorsSaga(),
    goalsSaga(),
    insightsSaga(),
    labTestSaga(),
    locationSaga(),
    medicationSaga(),
    offersSaga(),
    onboardingSaga(),
    patientSaga(),
    programSaga(),
    razorPaySaga(),
    recordsSaga(),
    reminderSaga(),
    appointmentSaga(),
    orderHistorySaga(),
    journeySaga(),
    symptomsSaga(),
    walletSaga(),
    cgmSaga(),
  ]);
}
